import { Dispatch } from 'redux';

import { Invoice, fetchInvoice as apiFetchInvoice } from 'api/invoices';

import { MainStoreErrorAction, setError } from './error';

// Types

export type MainStoreInvoicesState = {
  byId: Record<string, Invoice & { isFetching: boolean }>;
};

type FetchInvoiceRequestAction = {
  type: 'FETCH_INVOICE_REQUEST';
  invoiceId: string;
};
type FetchInvoiceSuccessAction = {
  type: 'FETCH_INVOICE_SUCCESS';
  invoice: Invoice;
};
export type MainStoreInvoicesAction =
  | FetchInvoiceRequestAction
  | FetchInvoiceSuccessAction;

// Reducer

export function invoicesReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreInvoicesState = {
    byId: {},
  },
  action: MainStoreInvoicesAction,
) {
  switch (action.type) {
    case 'FETCH_INVOICE_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invoiceId]: {
            ...state.byId[action.invoiceId],
            id: action.invoiceId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_INVOICE_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invoice.id]: { ...action.invoice, isFetching: false },
        },
      };

    default:
      return state;
  }
}

// Actions

const fetchInvoiceRequest = (invoiceId: string): FetchInvoiceRequestAction => ({
  type: 'FETCH_INVOICE_REQUEST',
  invoiceId,
});

const fetchInvoiceSuccess = (invoice: Invoice): FetchInvoiceSuccessAction => ({
  type: 'FETCH_INVOICE_SUCCESS',
  invoice,
});

export const fetchInvoice =
  (invoiceId: string) =>
  (
    dispatch: Dispatch<MainStoreInvoicesAction | MainStoreErrorAction>,
    getState: () => { invoices: MainStoreInvoicesState },
  ) => {
    const state = getState();
    const invoice = state.invoices.byId[invoiceId];

    if (!invoice) {
      dispatch(fetchInvoiceRequest(invoiceId));
      apiFetchInvoice(invoiceId)
        .then((fetchedInvoice) => {
          dispatch(fetchInvoiceSuccess(fetchedInvoice));
        })
        .catch((e) => {
          dispatch(setError(e));
        });
    }
  };
